import { render, staticRenderFns } from "./healthRecords.vue?vue&type=template&id=3c97de00&scoped=true&"
import script from "./healthRecords.vue?vue&type=script&lang=js&"
export * from "./healthRecords.vue?vue&type=script&lang=js&"
import style0 from "./healthRecords.vue?vue&type=style&index=0&id=3c97de00&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c97de00",
  null
  
)

export default component.exports